if (!customElements.get('m-breed-request')) {
  // Stan i konfiguracja trzymane na poziomie modulu (nie w instancji
  // elementu). Sekcja siatki produktow/wynikow wyszukiwania jest
  // przeladowywana przez AJAX przy kazdym filtrowaniu, wiec <m-breed-request>
  // bywa tworzony od nowa wielokrotnie na tej samej stronie. Gdyby modal i
  // globalne nasluchiwacze (submit/change/input/klik) byly rejestrowane w
  // kazdej instancji, po kilku filtrowaniach dublowalyby sie - std objaw:
  // modal otwiera sie "dwa razy" i trzeba klikac Zamknij dwukrotnie (a przy
  // wysylce formularza zgloszenie realnie wysylaloby sie kilka razy).
  // Dlatego nasluchiwacze inicjujemy dokladnie raz (flaga listenersReady),
  // a kazda kolejna instancja tylko odswieza tresc modala na najnowsza.
  var CONFIG = {
    webhookUrl: 'https://script.google.com/macros/s/AKfycbzu-gBUD3WlC8ZrT71h7KVlr0trpSWmcwjGdLE9KuZ5K9LQzGbd29-ieYCaNcVhGAJB/exec',
    maxPhotoSize: 15 * 1024 * 1024, // 15 MB (limit przed kompresja)
    maxPhotoDimension: 1600, // px, po tej stronie skalujemy dluzszy bok
    photoQuality: 0.82,
    fieldSpacing: { normal: '24px', error: '0px' }
  };

  var selectors = {
    openButton: '[data-open-breed-request]',
    content: '.m-form-breed-request',
    form: '[data-breed-request-form]',
    success: '.m-form-breed-request__success'
  };

  var state = {
    contentHtml: null,
    colorScheme: '',
    modal: null,
    listenersReady: false
  };

  // Wymusza odstepy przez inline style (z !important), bo CSS motywu ma
  // regule o identycznej sile dla <input>, ktora wygrywa z naszym arkuszem.
  function forceSpacing(root) {
    root.querySelectorAll('.form-field').forEach(function (el) {
      el.style.setProperty('width', '100%', 'important');
      el.style.setProperty('display', 'block', 'important');
      el.style.setProperty(
        'margin-bottom',
        el.classList.contains('has-error') ? CONFIG.fieldSpacing.error : CONFIG.fieldSpacing.normal,
        'important'
      );
    });
    root.querySelectorAll('.m-form-breed-request__field-error').forEach(function (el) {
      el.style.setProperty('margin', '8px 0 20px', 'important');
    });
  }

  function setFieldError(field) {
    field.classList.add('has-error');
    field.style.setProperty('border-color', '#d11010', 'important');
    field.style.setProperty('margin-bottom', CONFIG.fieldSpacing.error, 'important');
  }

  function setFieldValid(field) {
    field.classList.remove('has-error');
    field.style.removeProperty('border-color');
    field.style.setProperty('margin-bottom', CONFIG.fieldSpacing.normal, 'important');
  }

  function notifyError(message) {
    if (window.MinimogTheme && MinimogTheme.Notification) {
      MinimogTheme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'error',
        message: message,
        delay: 3000,
        sticky: true
      });
    }
  }

  // Wlasna walidacja po polsku, kazde pole ma wlasny komunikat pod soba -
  // natywne komunikaty przegladarki pokazuja sie w jezyku przegladarki
  // odwiedzajacego, dlatego formularz ma novalidate.
  function validateForm(form) {
    var breedField = form.querySelector('[name="breed"]');
    var emailField = form.querySelector('[name="email"]');
    var breedError = form.querySelector('[data-error-for="breed"]');
    var emailError = form.querySelector('[data-error-for="email"]');
    var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    setFieldValid(breedField);
    setFieldValid(emailField);
    if (breedError) breedError.classList.add('m:hidden');
    if (emailError) emailError.classList.add('m:hidden');

    var isValid = true;
    var firstInvalid = null;

    if (!breedField.value.trim()) {
      setFieldError(breedField);
      if (breedError) {
        breedError.textContent = 'Podaj rasę lub umaszczenie, którego szukasz.';
        breedError.classList.remove('m:hidden');
      }
      isValid = false;
      firstInvalid = firstInvalid || breedField;
    }

    if (!emailField.value.trim()) {
      setFieldError(emailField);
      if (emailError) {
        emailError.textContent = 'Podaj swój adres e-mail.';
        emailError.classList.remove('m:hidden');
      }
      isValid = false;
      firstInvalid = firstInvalid || emailField;
    } else if (!emailPattern.test(emailField.value.trim())) {
      setFieldError(emailField);
      if (emailError) {
        emailError.textContent = 'Podaj prawidłowy adres e-mail.';
        emailError.classList.remove('m:hidden');
      }
      isValid = false;
      firstInvalid = firstInvalid || emailField;
    }

    if (firstInvalid) firstInvalid.focus();
    return isValid;
  }

  // Skaluje/kompresuje zdjecie w przegladarce przed wyslaniem - dzieki temu
  // typowe zdjecie z telefonu (3-8 MB) zwykle spada do kilkuset KB, co mocno
  // przyspiesza wysylke i przetwarzanie po stronie Apps Script/Drive.
  function compressImage(file) {
    var maxDim = CONFIG.maxPhotoDimension;
    var quality = CONFIG.photoQuality;
    return new Promise(function (resolve) {
      if (!file.type || file.type.indexOf('image/') !== 0 || file.type === 'image/svg+xml') {
        readAsBase64(file).then(resolve);
        return;
      }
      var objectUrl = URL.createObjectURL(file);
      var img = new Image();
      img.onload = function () {
        URL.revokeObjectURL(objectUrl);
        var width = img.width;
        var height = img.height;
        if (!width || !height) {
          readAsBase64(file).then(resolve);
          return;
        }
        if (width > maxDim || height > maxDim) {
          if (width > height) {
            height = Math.round(height * (maxDim / width));
            width = maxDim;
          } else {
            width = Math.round(width * (maxDim / height));
            height = maxDim;
          }
        }
        try {
          var canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          var ctx = canvas.getContext('2d');
          ctx.drawImage(img, 0, 0, width, height);
          var dataUrl = canvas.toDataURL('image/jpeg', quality);
          var base64 = dataUrl.indexOf(',') > -1 ? dataUrl.split(',')[1] : '';
          resolve({ base64: base64, type: 'image/jpeg' });
        } catch (err) {
          console.warn('[breed-request] kompresja nieudana, wysyłam oryginał:', err);
          readAsBase64(file).then(resolve);
        }
      };
      img.onerror = function () {
        URL.revokeObjectURL(objectUrl);
        readAsBase64(file).then(resolve);
      };
      img.src = objectUrl;
    });
  }

  function readAsBase64(file) {
    return new Promise(function (resolve) {
      var reader = new FileReader();
      reader.onload = function () {
        var result = String(reader.result || '');
        resolve({ base64: result.indexOf(',') > -1 ? result.split(',')[1] : '', type: file.type });
      };
      reader.onerror = function () {
        resolve({ base64: '', type: file.type });
      };
      reader.readAsDataURL(file);
    });
  }

  function submitForm(form) {
    if (!CONFIG.webhookUrl || CONFIG.webhookUrl.indexOf('REPLACE_WITH') === 0) {
      console.warn('Breed request: webhookUrl nie jest jeszcze skonfigurowany.');
      return;
    }

    if (!validateForm(form)) return;

    var formData = new FormData(form);
    var fileInput = form.querySelector('[data-photo-input]');
    var file = fileInput && fileInput.files && fileInput.files[0];
    console.log('[breed-request] submit, plik w polu w momencie wysyłki:', file ? { name: file.name, size: file.size, type: file.type } : 'BRAK PLIKU');

    if (file && file.size > CONFIG.maxPhotoSize) {
      notifyError('Zdjęcie jest za duże (maks. 15 MB).');
      return;
    }

    var submitBtn = form.querySelector('[data-submit-btn]');
    var submitLabel = submitBtn ? (submitBtn.dataset.submitLabel || submitBtn.textContent) : '';
    if (submitBtn) {
      submitBtn.disabled = true;
      submitBtn.classList.add('m-loading');
      submitBtn.textContent = file ? 'Przygotowywanie zdjęcia...' : 'Wysyłanie...';
    }

    var resetButton = function () {
      if (submitBtn) {
        submitBtn.disabled = false;
        submitBtn.classList.remove('m-loading');
        submitBtn.textContent = submitLabel;
      }
    };

    var buildPayload = function (photoBase64, photoType) {
      return {
        email: formData.get('email'),
        breed: formData.get('breed'),
        company: formData.get('company'),
        source: window.location.href,
        photoBase64: photoBase64 || '',
        photoType: photoType || (file ? file.type : ''),
        photoName: file ? file.name : ''
      };
    };

    var send = function (payload) {
      if (submitBtn) submitBtn.textContent = 'Wysyłanie...';
      console.log('[breed-request] wysyłam payload:', {
        email: payload.email,
        breed: payload.breed,
        photoName: payload.photoName,
        photoType: payload.photoType,
        photoBase64Length: payload.photoBase64 ? payload.photoBase64.length : 0
      });

      fetch(CONFIG.webhookUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload)
      })
        .then(function (res) {
          return res.json().catch(function () { return null; }).then(function (json) { return { res: res, json: json }; });
        })
        .then(function (result) {
          var res = result.res;
          var json = result.json;
          console.log('[breed-request] odpowiedź serwera:', res.status, json);
          if (json && json.ok === false) {
            resetButton();
            notifyError('Zgłoszenie wysłane, ale wystąpił błąd: ' + (json.error || 'nieznany'));
            return;
          }
          var wrapper = form.closest('.m-form-breed-request__wrapper') || form.parentElement;
          var success = wrapper.querySelector(selectors.success);
          form.classList.add('m:hidden');
          if (success) success.classList.remove('m:hidden');
        })
        .catch(function (err) {
          console.error('[breed-request] błąd fetch:', err);
          resetButton();
          notifyError('Coś poszło nie tak. Spróbuj ponownie.');
        });
    };

    if (file) {
      compressImage(file).then(function (result) {
        console.log('[breed-request] zdjęcie przygotowane, długość base64:', result.base64.length, 'typ:', result.type);
        send(buildPayload(result.base64, result.type));
      });
    } else {
      send(buildPayload('', ''));
    }
  }

  // Nasluchiwacze globalne - rejestrowane raz na cala strone (patrz komentarz
  // na gorze pliku), niezaleznie od tego, ile razy sekcja z plytka/modalem
  // zostanie przeladowana przez AJAX (np. filtrowanie kolekcji).
  function initGlobalListeners() {
    if (state.listenersReady) return;
    state.listenersReady = true;

    addEventDelegate({
      selector: selectors.openButton,
      handler: function (e) {
        e.preventDefault();
        if (!state.contentHtml) return;
        if (!state.modal) state.modal = new MinimogTheme.Modal();
        var html = document.createElement('DIV');
        html.innerHTML = state.contentHtml;
        state.modal.appendChild(html);
        state.modal.setWidth('500px');
        state.modal.setSizes('m-form-breed-request-modal m-gradient ' + state.colorScheme);
        forceSpacing(html);
        state.modal.open();
      }
    });

    // Otwiera natywny wybor pliku - bez id/for, bo klon w modalu i ukryty
    // oryginalny szablon na stronie nie moga dzielic tego samego id.
    addEventDelegate({
      selector: '[data-photo-trigger]',
      handler: function (e, target) {
        e.preventDefault();
        var wrapper = target.closest('.m-form-breed-request__photo');
        var input = wrapper && wrapper.querySelector('[data-photo-input]');
        if (input) input.click();
      }
    });

    document.addEventListener('submit', function (e) {
      var form = e.target.closest(selectors.form);
      if (!form) return;
      e.preventDefault();
      submitForm(form);
    });

    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-photo-input]')) return;
      var wrapper = e.target.closest('.m-form-breed-request__photo');
      var label = wrapper && wrapper.querySelector('[data-photo-filename]');
      if (!label) return;
      var file = e.target.files && e.target.files[0];
      console.log('[breed-request] plik wybrany:', file ? { name: file.name, size: file.size, type: file.type } : null);
      label.textContent = file ? file.name : 'Nie wybrano pliku';
    });

    document.addEventListener('input', function (e) {
      if (!e.target.matches('[name="breed"], [name="email"]')) return;
      setFieldValid(e.target);
      var form = e.target.closest(selectors.form);
      var errorEl = form && form.querySelector('[data-error-for="' + e.target.name + '"]');
      if (errorEl) errorEl.classList.add('m:hidden');
    });
  }

  customElements.define(
    'm-breed-request',
    class MBreedRequest extends HTMLElement {
      connectedCallback() {
        var contentEl = this.querySelector(selectors.content);
        if (!contentEl) return;
        // Zawsze odswieza najnowsza tresc/kolor - na wypadek gdyby sekcja
        // zostala przeladowana przez AJAX z inna wersja znacznika.
        state.colorScheme = contentEl.dataset.colorScheme || '';
        // innerHTML, nie outerHTML - inaczej klasa m:hidden trafia do modala.
        state.contentHtml = contentEl.innerHTML;
        initGlobalListeners();
      }
    }
  );
}
